var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8815 1.2506L11.5671 1.39058L11.6953 1.70995L15.0964 10.18C17.0554 15.0588 14.918 20.6227 10.1964 22.9351L1.76011 27.0667L1.45087 27.2182L1.59092 27.5328L1.8076 28.0194L1.94765 28.334L2.26711 28.2055L10.9826 24.7007C15.8604 22.7392 21.4253 24.8737 23.7401 29.5941L27.7588 37.7892L27.9104 38.0982L28.2248 37.9582L28.7114 37.7416L29.0258 37.6016L28.8976 37.2822L25.4965 28.8122C23.5375 23.9333 25.6749 18.3695 30.3965 16.0571L38.8328 11.9254L39.142 11.774L39.002 11.4594L38.7853 10.9727L38.6452 10.6582L38.3258 10.7867L29.6103 14.2914C24.7325 16.253 19.1676 14.1184 16.8528 9.39802L12.8341 1.20295L12.6825 0.893953L12.3681 1.03393L11.8815 1.2506ZM16.8654 11.7899C19.4553 15.2178 23.801 16.8813 28.0186 16.0579C24.5846 18.6413 22.913 22.9839 23.7275 27.2023C21.1376 23.7744 16.7919 22.1109 12.5743 22.9342C16.0083 20.3508 17.6798 16.0083 16.8654 11.7899Z",
    fill: "#0078FF",
    stroke: "#0078FF",
    strokeWidth: 0.714286
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWide);
export default __webpack_public_path__ + "static/media/wide.0d71b07ab9f7f959598578499f3afece.svg";
export { ForwardRef as ReactComponent };